export function getTimeOnlyInMs(date: Date | string): number {
  const d = new Date(date);
  return d.getHours() * 3600000 + d.getMinutes() * 60000;
}

export function formatDate(date: Date): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
